import { CellClassParams } from '@ag-grid-community/core';

export const hasErrors = (params: CellClassParams): boolean => {
  return params.data?.errors && params.data.errors.length > 0;
};

export const getRowErrorClassRules = () => ({
  'error-row-cell': (params: CellClassParams) => hasErrors(params)
});

export const getErrorTextClassRules = () => ({
  'error-row-cell': (params: CellClassParams) => hasErrors(params),
  'error-text': (params: CellClassParams) => hasErrors(params)
});

export const formatErrorDescriptions = (errors: { errorDescription: string }[]): string =>
  errors && errors.length > 0 ? errors.map((e) => `• ${e.errorDescription}`).join('\n') : '';
